import PropTypes from 'prop-types';
import locationProps from './location-props';

const historyProps = PropTypes.shape({
  action: PropTypes.string,
  block: PropTypes.func,
  go: PropTypes.func,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  length: PropTypes.number,
  listen: PropTypes.func,
  location: locationProps,
  push: PropTypes.func,
  replace: PropTypes.func,
});

export default historyProps;
